import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
export var RadioModule;
(function (RadioModule) {
    let StatusFlags;
    (function (StatusFlags) {
        StatusFlags[StatusFlags["BASE_INIT_FLAG"] = 1] = "BASE_INIT_FLAG";
        StatusFlags[StatusFlags["S_ANSWER_RECEIVED"] = 2] = "S_ANSWER_RECEIVED";
        StatusFlags[StatusFlags["NO_CONNECTION_FLAG"] = 4] = "NO_CONNECTION_FLAG";
        StatusFlags[StatusFlags["IS_ADD_ENABLE_FLAG"] = 8] = "IS_ADD_ENABLE_FLAG";
        StatusFlags[StatusFlags["NO_CONNECT_EVENT_FLAG"] = 16] = "NO_CONNECT_EVENT_FLAG";
    })(StatusFlags = RadioModule.StatusFlags || (RadioModule.StatusFlags = {}));
    function isBuiltinRadioModule433(module) {
        return module.serial == '0001';
    }
    RadioModule.isBuiltinRadioModule433 = isBuiltinRadioModule433;
    RadioModule.get = createAccessors(arrayGetSet('radiomodules'), {
        serial: '',
        name: 'Радио-модуль',
        type: 0,
        notification_list: [],
        connection_timeout: 60,
    });
})(RadioModule || (RadioModule = {}));
